import { render, staticRenderFns } from "./StudentClassProjectionAddEdit.vue?vue&type=template&id=65a001a7"
import script from "./StudentClassProjectionAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentClassProjectionAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports